import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Smartphone } from "lucide-react";
import { formatCurrency, API_URL } from "../../lib/utils";
import { AppyPayWaitDialog } from "./AppyPayWaitDialog";

const PRICES = { bronze: { monthly: 8999, annual: 7199.2 }, ouro: { monthly: 79999.99, annual: 63999.99 } };

export const PlanAppyPayCard = ({ headers, cycle, onPaid }) => {
  const [plan, setPlan] = useState("ouro");
  const [phone, setPhone] = useState("");
  const [charge, setCharge] = useState(null);
  const [busy, setBusy] = useState(false);
  const total = PRICES[plan][cycle] * (cycle === "annual" ? 12 : 1);

  const start = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API_URL}/company/plan/pay/appypay`, { plan, billing_cycle: cycle, phone_number: phone }, { headers, withCredentials: true });
      setCharge(r.data);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erro ao iniciar pagamento");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card className="border-emerald-500/30" data-testid="plan-appypay-card">
      <CardContent className="p-5 space-y-3">
        <div className="flex items-center gap-2">
          <Smartphone className="w-5 h-5 text-emerald-500" />
          <p className="font-semibold">Pagar com Multicaixa Express (AppyPay)</p>
        </div>
        <p className="text-sm text-muted-foreground">Indique o telemóvel associado ao Multicaixa Express, aprove na app e a subscrição é ativada automaticamente — sem esperar por chave.</p>
        <div className="flex flex-wrap gap-2 items-end">
          <div className="space-y-1">
            <label className="text-xs text-muted-foreground">Plano</label>
            <select value={plan} onChange={(e) => setPlan(e.target.value)} className="h-10 rounded-md border bg-background px-3 text-sm" data-testid="plan-appypay-plan-select">
              <option value="bronze">LUMORA Bronze</option>
              <option value="ouro">LUMORA Ouro</option>
            </select>
          </div>
          <div className="space-y-1">
            <label className="text-xs text-muted-foreground">Telemóvel (Multicaixa Express)</label>
            <Input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="923 000 000" className="w-44 font-mono" data-testid="plan-appypay-phone" />
          </div>
          <Button onClick={start} disabled={busy || phone.replace(/\D/g, "").length < 9} className="bg-emerald-600 hover:bg-emerald-500 text-white" data-testid="plan-appypay-pay-btn">
            Pagar {formatCurrency(total)} ({cycle === "annual" ? "anual" : "mensal"})
          </Button>
        </div>
      </CardContent>
      <AppyPayWaitDialog charge={charge} headers={headers} title="Pagamento da subscrição" onSuccess={() => { toast.success("Subscrição ativada!"); onPaid?.(); }} onClose={() => setCharge(null)} />
    </Card>
  );
};
